import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const MaintenancePortalIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 52 52',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      viewBox="0 0 52 52"
    >
      <g transform="translate(-1734 -314)">
        <circle
          fill="#eff2f7"
          cx="26"
          cy="26"
          r="26"
          transform="translate(1734 314)"
        />
        <g transform="translate(1114.074 513.001)">
          <path
            fill="#224060"
            d="M643.052-175.2a6.431,6.431,0,0,1-3.572,3.351l.966,27.612a25.538,25.538,0,0,1-7.086-2.644l1.113-25.137a6.457,6.457,0,0,1-3.177-8.548,6.472,6.472,0,0,1,5.62-3.767l-2.063,4.522,5.3,2.422,2.063-4.522A6.45,6.45,0,0,1,643.052-175.2Z"
            transform="translate(0 -3.311)"
          />
          <path
            fill="#224060"
            d="M673.566-156.85v6.258a25.375,25.375,0,0,1-11.587,3.551v-9.809a3.463,3.463,0,0,1,3.461-3.461h.116v-15.814a2.291,2.291,0,0,1-1.863-2.095l-.158-2.248a3.018,3.018,0,0,1,.026-.691l1.525-10.184h5.377l1.525,10.184a3.356,3.356,0,0,1,.026.691l-.164,2.248a2.291,2.291,0,0,1-1.863,2.095v15.814h.121A3.459,3.459,0,0,1,673.566-156.85Z"
            transform="translate(-14.769 0)"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default MaintenancePortalIcon;
